export function negotiateLanguage(langs: readonly string[], defaultLang: string, acceptLang: readonly string[]) {
  if (!acceptLang) return defaultLang;

  // Поиск первого совпадения
  for (var k = 0; k < acceptLang.length; k++) {
    var current = acceptLang[k];

    // Проверка полного совпадения
    if (langs.indexOf(current) !== -1) {
      return current;
    }

    // Проверка основного тега (без региона)
    var primaryTag = current.split("-")[0];
    if (langs.indexOf(primaryTag) !== -1) {
      return primaryTag;
    }
  }

  return defaultLang;
}
